import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=843e3662&scoped=true"
import script from "./ProjectMembers.vue?vue&type=script&lang=js"
export * from "./ProjectMembers.vue?vue&type=script&lang=js"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=843e3662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843e3662",
  null
  
)

export default component.exports